import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import moment from 'moment'

import Portico from '@ordernext/networking-stadium/portico'
import Stadium from '@ordernext/networking-stadium/stadium'

export const redirectToLogin = () => {
  window.location.href = '/login'
  return null
}

export const isAuth = () => !isEmpty(getToken())

export const getToken = () => localStorage.getItem('accessToken')

export const logOut = () => {
  localStorage.removeItem('expiresAt')
  localStorage.removeItem('accessToken')
  window.location.href = '/login'
}

export const updateTokens = response => {
  const accessToken = get(response, 'data.accessToken')
  const expiresAt = get(response, 'data.expiresAt')

  if (accessToken && expiresAt) {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('expiresAt', expiresAt)

    Stadium.config = {
      ...Stadium.config,
      headers: {
        ...Stadium.config.headers,
        Authorization: `Bearer ${accessToken}`,
      },
    }
  }
}

export const authenticateDevice = () => {
  const deviceId = window.localStorage.device_id
  const appKey = process.env.REACT_APP_OIDC_CLIENT_ID
  const organizationName = process.env.REACT_APP_ORG
  Portico.deviceLogin(deviceId, appKey, organizationName)
    .then(updateTokens)
    .catch(() => {})
}

export const checkTokenExpireTime = () => {
  const ONE_MINUTE = 60000
  const ONE_HOUR = ONE_MINUTE * 60

  if (!localStorage.getItem('expiresAt')) return null

  const expiresAt = moment(localStorage.getItem('expiresAt'))
  const tokenMillisecondsRemaining = expiresAt.diff(moment())

  if (tokenMillisecondsRemaining < ONE_HOUR) {
    authenticateDevice()
  }
}
